<div class="multiple-logos container" *ngIf="billerCodes?.length > 1; else singleLogo">
  <app-biller-logo [billerCode]="billerCodes[0]" [class]="'logo bottom'" [size]="24"></app-biller-logo>
  <app-biller-logo [billerCode]="billerCodes[1]" [class]="'logo top'" [size]="24"></app-biller-logo>
</div>

<ng-template #singleLogo>
  <div *ngIf="billerCodes?.length === 1" class="container">
    <app-biller-logo [billerCode]="billerCodes[0]" [size]="36"></app-biller-logo>
  </div>
</ng-template>
